<template>
  <div class="analyze_warp">
    <div class="left">
      <div class="title">
        学习数据
      </div>
      <div class="content">
        <div class="item">
          <div>{{info.paper_count}}</div>
          <div>总提交试卷</div>
        </div>

        <div class="item">
          <div>
            {{info.paper_detail_count}}
          </div>
          <div>完成题目</div>
        </div>

        <div class="item">
          <div>
            {{info.paper_point}}
          </div>
          <div>总得分率(%)</div>
        </div>

        <div class="item">
          <div>
            {{info.score_change}}
          </div>
          <div>得分率变化(%)</div>
        </div>
      </div>
    </div>
    <div class="right">
      <!--  -->
      <div @click="showMessage('/knowledge/line')">
        <span class="text">
          <span>
            考点曲线
          </span>
          <span>
            考点得分率变化情况
          </span>
        </span>
        <span class="img">
          <img src="@/static/analyze/zhishidian.png"
               alt="">
        </span>
      </div>
      <!--  -->
      <div @click="showMessage('/studentAnalysis')">
        <span class="text">
          <span>
            学情分析
          </span>
          <span>
            查看各科弱点情况
          </span>
        </span>
        <span class="img">
          <img src="@/static/analyze/xueqing.png"
               alt=""></span>
      </div>
    </div>
      <div class="autoModal"
         v-if="autoModalFlag">
      <div class="openButton">

        <a-button type="warning"
                   @click="toBuy"
                   class="btntext"><span class="text">开通VIP享受全部功能</span></a-button>
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref ,onMounted} from 'vue'
import { instance } from '@/utils/http.js'
import { useRouter } from 'vue-router'
let info = ref({})
let router = useRouter()
const getInfo = async () => {
  const { data } = await instance({
    url: '/api/v1/user/user_report',
    method: 'get'
  })
  info.value = data
}
let autoModalFlag = ref(false)
onMounted(() => {
   
     let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    if (userInfo.user_type_id == 101 && !userInfo.vip_end_time) {
      autoModalFlag.value = true
    }
})
getInfo()
const showMessage = (path) => {
  // if (this.timeOutId) {
  //   return
  // }
  // this.timeOutId = setTimeout(() => {
  //   this.timeOutId = 0
  // }, 1500)
  // this.$message.warning('暂无数据')

  router.push(path)
}
const toBuy = () => {
  router.push('/buyVip')
}

</script>

<style lang="scss" scoped>
.analyze_warp {
  display: flex;
  .autoModal { 
    position: fixed;
    left: 197 !important;
    top: 0;
    width: 90%;
    height: 100%;
    opacity: 1.5;
    z-index: 9999;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
    .btntext {
      position: fixed;
      left: 800rem;
      top: 700rem;
      .text {
        color: var(--light-333333, #333);
        text-align: center;

        font-size: 24rem;
        font-style: normal;
        font-weight: 600;
        line-height: 36rem; /* 150% */
      }
    }
    .openButton {
      ::v-deep .ant-btn {
        display: flex;
        width: 360rem;
        height: 64rem;
        justify-content: center;
        align-items: center;
        gap: 10rem;
        flex-shrink: 0;
        border-radius: 8rem;
        background: linear-gradient(100deg, #fdecc9 0%, #e9c383 100%);
        box-shadow: 0rem 8rem 16rem 0rem rgba(0, 0, 0, 0.1);
      }
    }
  }
  .left {
    overflow: hidden;
    position: relative;
    width: 583rem;
    height: 824rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("../../static/analyze/study1.png");
    margin: 65rem 101rem 0 162rem;
    .title {
      text-align: center;
      margin-top: 377rem;
      font-size: 36rem;
      font-weight: 800;
      color: #b05c27;
    }
    .content {
      position: absolute;
      bottom: 10px;
      width: 543rem;
      height: 340rem;
      left: 10px;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        div {
          &:nth-child(1) {
            font-size: 50rem;
            font-weight: 800;
            color: #b65d25;
          }
          &:nth-child(2) {
            font-size: 28rem;
            font-weight: 500;
            color: #a98873;
          }
        }
      }
    }
  }
  .right {
    margin-top: 160rem;
    div {
      width: 749rem;
      height: 320rem;
      box-shadow: 0px 0px 0px 0px rgba(229, 229, 229, 1);
      border-radius: 60rem;
      border: 20rem solid #fac376;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
      cursor: pointer;
      .text {
        flex: 1;
        margin-left: 80rem;
        span {
          display: block;
          &:nth-child(1) {
            font-size: 40rem;
            font-weight: 800;
            color: #000000;
          }
          &:nth-child(2) {
            font-size: 28rem;
            font-weight: bold;
            color: #666666;
            margin-top: 20rem;
          }
        }
      }
      .img {
        margin-right: 90rem;
        img {
          width: 160rem;
          height: 160rem;
        }
      }
      &:nth-child(2) {
        margin-top: 90rem;
      }
    }
  }
}
</style>